import { useStore } from "vuex"

export default {
    name: "FrivilligGroupHero",
    props: {
        isLoggedIn: {
            type: Boolean,
            required: true
        },
        loginUrl: {
            type: String,
            required: false
        },
        closedGroup: {
            type: Boolean,
            required: false
        },
        gruppeKode: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const openCalendarOverlay = () => {
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'CalendarOverlay'
            })
        }

        const openMedlemsOverlay = () => {
            store.commit('main/set_page_overlay_content_data', { groupId: props.gruppeKode })

            store.dispatch('main/openPageOverlay', {
                overlayContent: 'MemberListOverlayFrivillig'
            })
        }
        
        const joinGroup = async () => {

            if (!props.isLoggedIn) {
                window.location.href = props.loginUrl
                return
            }

            if (!props.closedGroup)
            {
                await store.dispatch('frivillige/joinGroup', {
                    gruppeKode: props.gruppeKode,
                })
                window.location.reload()
                return;
            }

            store.commit('main/set_page_overlay_content_data', { isFrivilligContext: true })
            store.dispatch('main/openPageOverlay', {
                overlayContent: 'ClosedGroupOverlay',
            })
        }

        return {
            openCalendarOverlay,
            openMedlemsOverlay,
            joinGroup
        }
    }
}